import React from "react";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import { Contact as ContactModel } from "../../../app/data/terminal-details/models";
import {
    useFormikContext,
} from 'formik';

const Contact = () => {

    const { values, setFieldValue, handleBlur, setFieldTouched } = useFormikContext<ContactModel>();
    return (
        <div className="edit-flex-box">
            <XGSFormInput
                type="text"
                name="phoneNumber"
                required={true}
                labelMode={LabelModes.column}
                label="Phone Number"
                onBlur={async (e) => {
                    // First, let Formik handle the blur (for validation)
                    handleBlur(e);

                    // Then format the phone number
                    const formattedPhone = values.phoneNumber?.formatPhone();
                    if (formattedPhone !== "") {
                        await setFieldValue('phoneNumber', formattedPhone);
                        // Trigger validation after formatting
                        setFieldTouched('phoneNumber', true);
                    }
                }} />
            <XGSFormInput
                type="text"
                name="terminalEmail"
                required={true}
                labelMode={LabelModes.column}
                label="Terminal Email Distribution List"
            />
        </div>
    );
};

export default Contact;
